import React from 'react';
import { tone } from './tones';

/** Titled content block. `extra` renders on the right of the header; `flush` removes body padding (tables). */
export default function SectionCard({ title, description, icon, iconTone = 'neutral', extra, children, flush = false, className = '', bodyClassName = '' }) {
    const hasHeader = title || extra;
    return (
        <section className={`shelf-card ${className}`}>
            {hasHeader && (
                <div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-surface-100">
                    <div className="flex items-center gap-2.5 min-w-0">
                        {icon && <span className={`flex h-7 w-7 items-center justify-center rounded-md text-sm ${tone(iconTone).chip}`}>{icon}</span>}
                        <div className="min-w-0">
                            <h2 className="m-0 text-[15px] font-semibold text-surface-900 truncate">{title}</h2>
                            {description && <p className="m-0 text-xs text-surface-500">{description}</p>}
                        </div>
                    </div>
                    {extra && <div className="flex items-center gap-2 shrink-0">{extra}</div>}
                </div>
            )}
            <div className={`${flush ? '' : 'p-5'} ${bodyClassName}`}>{children}</div>
        </section>
    );
}
